module.exports = __webpack_public_path__ + "static/media/route_history_off.dd102c3a.png";